import React, { useEffect, useRef, useState } from "react"
import { createPortal } from "react-dom"
import { MdMoreVert } from "react-icons/md"
import styles from "./modalTransactions.module.css"

const MENU_WIDTH = 220

const TransactionActionsMenu = ({ actions = [] }) => {
    const [isOpen, setIsOpen] = useState(false)
    const [position, setPosition] = useState({ top: 0, left: 0 })
    const triggerRef = useRef(null)

    useEffect(() => {
        if (!isOpen) return undefined
        const close = () => setIsOpen(false)
        const handleKeyDown = event => {
            if (event.key === "Escape") close()
        }
        window.addEventListener("resize", close)
        window.addEventListener("scroll", close, true)
        document.addEventListener("keydown", handleKeyDown)
        return () => {
            window.removeEventListener("resize", close)
            window.removeEventListener("scroll", close, true)
            document.removeEventListener("keydown", handleKeyDown)
        }
    }, [isOpen])

    const toggleMenu = event => {
        event.stopPropagation()
        if (isOpen) {
            setIsOpen(false)
            return
        }

        const rect = triggerRef.current?.getBoundingClientRect()
        if (!rect) return
        const margin = 10
        const estimatedHeight = actions.length * 42 + 10
        const openAbove = rect.bottom + estimatedHeight + margin > window.innerHeight && rect.top > estimatedHeight
        setPosition({
            top: openAbove ? Math.max(margin, rect.top - estimatedHeight - 6) : rect.bottom + 6,
            left: Math.min(Math.max(margin, rect.right - MENU_WIDTH), window.innerWidth - MENU_WIDTH - margin),
        })
        setIsOpen(true)
    }

    const runAction = action => {
        setIsOpen(false)
        action.onClick?.()
    }

    if (!actions.length) return null

    return <div className={styles.actionMenu}>
        <button ref={triggerRef} type="button" className={isOpen ? styles.actionMenuTriggerActive : ""} onClick={toggleMenu} aria-label="Ações do lançamento" aria-haspopup="menu" aria-expanded={isOpen} title="Ações">
            <MdMoreVert />
        </button>
        {isOpen && createPortal(<>
            <button type="button" className={styles.actionMenuBackdrop} onClick={() => setIsOpen(false)} aria-label="Fechar menu de ações" />
            <div className={styles.actionMenuPanel} style={position} role="menu">
                {actions.map(action => <button key={action.label} type="button" role="menuitem" className={action.danger ? styles.dangerAction : ""} onClick={() => runAction(action)}>
                    {action.icon}<span>{action.label}</span>
                </button>)}
            </div>
        </>, document.body)}
    </div>
}

export default TransactionActionsMenu
